<!--
    @file:websocket组件
    @props: {object} sendMessage 根据API所要求格式传递数据
        //example
        {
            topic: 'vehicle_choose',
            action: 'create',
            data: {
                id: id
            }
        }
    @emit {object} select 给父组件传递选中的对象
    @emit onopen websocket服务器连接成功
    @emit onclose websocket服务器断开链接
    @emit 根据数据返回的topic作为emit的名称,把对应的数据传给对应的父组件

-->
<template>
</template>
<script>
export default {
    name: 'ws',
    created () {
        this.init();
    },
    beforeDestroy () {
        this.ws.close();
    },
    data () {
        return {
            ws: null
        };
    },
    props: ['sendMessage'],
    methods: {
        init () {
            var self = this;
            this.ws = new WebSocket(this.Api.ws);
            var tickHeartpac;
            this.ws.onopen = function (event) {
                tickHeartpac = setInterval(function () {
                    self.ws.send(JSON.stringify({topic: 'ping'}));
                }, 40000);
                self.$emit('onopen');
            };

            this.ws.onclose = function (event) {
                clearInterval(tickHeartpac);
                tickHeartpac = null;
                self.$emit('onclose');
            };

            this.ws.onmessage = function (event) {
                var message = JSON.parse(event.data);
                self.$emit(message.topic, message.data);
            };
        }
    },
    watch: {
        sendMessage (val) {
            this.ws.send(JSON.stringify(val));
        }
    }
};
</script>



// WEBPACK FOOTER //
// ws.vue?712458a4